var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contact"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.contInfo.info.content)}},[_vm._v("\n    "+_vm._s(_vm.contInfo.info.content)+"\n  ")]),_vm._v(" "),_c('a',{staticClass:"call-company",attrs:{"href":"/contact"}},[_vm._v("联系我们")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6240e066","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/company_contact.vue
// module id = null
// module chunks = 